<template>
  <v-flex>
    <v-dialog v-model="showModal" max-width="90%">
      <customer-address
        :add="true"
        @close="showModal = false"
      ></customer-address>
    </v-dialog>
    <v-dialog v-model="showContact" max-width="90%">
      <contact-modal
        v-if="showContact"
        :contact="contact"
        @closeContact="contactClosed"
      ></contact-modal>
    </v-dialog>

    <v-card>
      <v-card-title>
        <h3>
          <slot></slot>
        </h3>
        <!-- <v-checkbox v-model="checkbox2" label="Use the same address for postal?"></v-checkbox> -->
      </v-card-title>
      <v-layout justify-start row>
        <v-flex>
          <v-radio-group
            v-model="model"
            v-validate="'required'"
            column
            :error-messages="errors.collect('pMContactPhoneNumber')"
          >
            <v-radio
              v-for="(address, index) in addressList"
              :key="index"
              :label="address.formattedAddress"
              :value="address.formattedAddress"
            ></v-radio>
          </v-radio-group>
        </v-flex>
      </v-layout>
      <v-card-actions>
        <v-btn color="primary" large @click="showModal = true">
          Add Address
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
const { mapActions: mapUtilityActions } =
  createNamespacedHelpers(`orders/utility`);

export default {
  name: 'UtilityAddress',
  inject: {
    $validator: '$validator',
  },
  props: {
    disable: Boolean,
    model: String,
    addressList: Array,
    isAnon: Boolean,
  },
  data() {
    return {
      showModal: false,
      showContact: false,
    };
  },
  methods: {
    ...mapUtilityActions([
      'addAddress',
      'addAddressAnon',
      'getCustomerAddresses',
    ]),
  },
};
</script>

<style></style>
